import { io, type Socket } from 'socket.io-client'

let socket: Socket | null = null

/**
 * Ein einziger Socket.IO-Client für die gesamte App (Chat + Notifications teilen sich
 * dieselbe Verbindung). Authentifizierung läuft über das Session-Cookie (withCredentials),
 * kein separates Realtime-Token — siehe docs/ARCHITECTURE.md#8-realtime-architektur.
 */
export function getSocket(): Socket {
  if (!socket) {
    socket = io('/', { path: '/ws', withCredentials: true, autoConnect: true })
  }
  return socket
}

export function disconnectSocket(): void {
  socket?.disconnect()
  socket = null
}
